import moment from 'moment';

export const bulkMailVendorConfig = {
  api: () => '/bulk-mails-vender',
  title: 'Mails',
  isActionTab: true,
  modalTitle: (action) => `${action}  Mails`,
  getColumns: () => {
    return [
      {
        title: 'Mail From',
        dataIndex: 'mailFrom',
        key: 'mailFrom',
        isSearch: true,

      },
      {
        title: 'Email To',
        dataIndex: 'mailTo',
        key: 'mailTo',
        type: 'viewList',
        render: (text) => {
          return text.split(/[\s,;<>]+/);
        }
      },
      {
        title: 'Mail Status',
        dataIndex: 'mailStatus',
        key: 'mailStatus',
        isSearch: true,
      },
      {
        title: 'Email Template',
        dataIndex: 'emailTemplate',
        key: 'emailTemplate',
        isSearch: true,
      },
      {
        title: 'Sent On',
        dataIndex: 'createdAt',
        key: 'createdAt',
        isSearch: true,
        render: (text) => {
          return moment(text).format('DD MMM YYYY');
        },
      },
    ];
  },
  getFormColumns: () => {
    return [
      {
        title: 'Mail From',
        dataIndex: 'mailFrom',
        key: 'mailFrom',
        type: 'select',
        children: [
          { name: 'hire@accelgrowthtech.com', value: 'Hire' },
          { name: 'no-reply@accelgrowthtech.com', value: 'No Reply' },
          { name: 'sophia@accelgrowthtech.com', value: 'Sophia' },
        ],
        isRequired: true,
        formClassName: 'col-4 pb-2',
      },
      {
        title: 'Email Template',
        dataIndex: 'emailTemplate',
        key: 'emailTemplate',
        isRequired: true,
        type: 'select',
        isCombo: true,
        formClassName: 'col-4 pb-2',
      },
      {
        title: 'Requirment',
        dataIndex: 'requirment',
        key: 'requirment',
        type: 'textQuill',
        isRequired: true,
        formClassName: 'col-8 pb-2',
      }
    ];
  },
  combo: [
    {
      name: 'emailTemplate',
      api: '/cms/emailTemplates',
      idKey: '_id',
      nameKey: ['name'],
    }
  ],
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  getData: () => ({}),
  actions: [
    { name: 'Add Mail', isModal: true, settings: { type: 'primary' } },
    { name: 'Return', isBack: true, settings: { type: 'primary' } },
  ],
};
